<template>
    <div class="art-cont">
                    <h1 class="fs28 lh38">星火体系 | “星火·链网”骨干节点（珠海横琴）创新应用——“澳优码”亮相澳门科技博览会</h1>
                    <div class="title-info">2021-12-07</div>
                    <div class="main-content">
                        <p>
	12月2日-4日，首届BEYOND 国际科技创新博览会在澳门盛大召开。博览会由澳门科技总会(MTGA)主办，商务部外贸发展局、国务院国资委规划发展局、中国国际科技交流中心和中华医学会合办。大会聚焦前言科技，进一步释放澳门产业多元发展活力，促进澳门与国际科技界展开交流合作。“星火·链网”骨干节点（珠海横琴）的创新应用——“澳优码”亮相博览会。
</p>
<p>
	<br>
</p>
<p>
	横琴融贯投资科技有限公司董事长冯文滔作为“星火·链网”骨干节点（珠海横琴）的运营单位代表，在博览会现场向澳门特区行政长官贺一诚讲解了“星火·链网”骨干节点（珠海横琴）的创新应用——“澳优码”，获得贺一诚一行的肯定与好评。
</p>
<p>
	<br>
</p>
<p style="text-align:center;">
	<img src="/core/extend/kindeditor/attached/image/20220228/20220228175427_84108.jpg" alt="图片" style="width:677px;height:auto !important;" ondragstart="return false"> 
</p>
<p style="text-align:center;">
	澳门特区行政长官贺一诚参观澳优码展台
</p>
<p>
	<br>
</p>
<p style="text-align:center;">
	<img src="/core/extend/kindeditor/attached/image/20220228/20220228175723_77842.jpg" alt="图片" style="height:315.48px !important;width:677px !important;" ondragstart="return false"> 
</p>
<p>
	<br>
</p>
<p>
	“澳优码”是基于“星火·链网”骨干节点（珠海横琴）打造的创新应用，由浪潮集团联合融贯国际、普华永道等10家机构基于“星火·链网”和浪潮云洲工业互联网平台，提供一键追溯、质量保障、数字营销、价值回馈等多重价值。“澳优码”面向粤港澳大湾区，提供区块链和工业互联网标识解析等服务，通过数字身份、一物一码，构建质量保障立体体系，助力澳门监制。在博览会现场，赋有“澳优码”的多种产品亮相展示，吸引参展者驻足观看，扫码体验。
</p>
<p style="text-align:center;">
	<img src="/core/extend/kindeditor/attached/image/20220228/20220228175759_45009.jpg" alt="图片" style="height:auto !important;width:677px;" ondragstart="return false"> 
</p>
<p style="text-align:center;">
	龙泉青瓷澳优码扫码界面
</p>
<p>
	<br>
</p>
<p>
	“带你了解该产品遇见你之前都经历了什么。”手机扫描龙泉青瓷点彩杯包装盒中的“澳优码”，产品详情、质量追溯、企业文化映入眼帘，区块链ID清晰可见，原料、成型、晾坯、修坯、素烧、上釉、釉烧等生产工序一目了然，实现原料、生产、流通等全生命周期追溯，更容易让人产生质量信任。
</p>
<p>
	<br>
</p>
<p>
	除了艺术行业的陶瓷链，“澳优码”已建立中医药行业的中药链、食品行业的茶叶链，上链品类已覆盖一产、民生、金融等领域。陈李济中药材、梧州六堡茶等，均已应用赋码，提质增效。“澳优码”平台在融合区块链、标识解析等数字技术基础上，不断构筑良性发展生态。在11月30日举行的2021粤港澳数字贸易创新应用峰会暨“星火·链网”骨干节点（珠海横琴）-横琴粤澳链发布会上，横琴融贯等数十家机构举行了创新应用签约仪式，共筑“澳优码”生态，驱动数据自由流动，促进数字技术深度赋能数字经济。未来，“澳优码”将不断提升共性技术能力，拓展应用场景，赋能澳门产业多元发展与数字化转型，助力粤港澳大湾区高质量发展。
</p>
<p>
	<br>
</p>
<p style="text-align:center;">
	<strong>“星火·链网”</strong> 
</p>
“星火·链网”是在工信部的领导与专项支持下，由中国信通院牵头、联合北航、北邮、中国联通等多家大型企事业单位建设的国家区块链新型基础设施。是为持续推进产业数字化转型，推动数字资产价值化，利用区块链自主创新能力而谋划布局面向数字经济“新型基础设施”；其以代表产业数字化转型的工业互联网为主要应用场景，以网络标识这一数字化关键资源为突破口，推动区块链的应用发展，实现新基建的引擎作用。“星火·链网”建设策略及治理模式开放，定位于面向全球服务的国家级区块链新型基础设施，2020年8月正式启动部署。2021年8月3日，中国信通院正式发布了“星火·链网”底层区块链系统（BIF-Core),标志“星火·链网”主链正式启动运行并开始向全球进行服务。
<p>
	“星火·链网”骨干节点是整个“星火·链网”双层体系架构中锚定对接超级节点主链与行业/区域链的一类关键角色，目前采用产业力量主导的“开放生态建设”原则和发展模式。
</p>
<p>
	<br>
</p>
<p style="text-align:center;">
	<strong>“星火·链网”骨干节点（珠海横琴）</strong>
</p>
<p>
	“星火·链网”骨干节点（珠海横琴）是由浪潮云洲旗下的广东云湾工业互联网有限公司作为建设主体，由珠海横琴融贯国际科技发展公司作为运营主体，依托骨干节点技术供应商北京泰尔英福科技有限公司的区块链技术而设计的。该骨干节点基于“星火·链网”的建设要求，面向粤港澳各行业提供稳定的区块链和标识解析等服务，通过区块链资源分配和管理、标识注册及解析服务、信息系统建设和运营、服务应用对接和推广等工作，提高区块链在不同场景中的应用能力，构建以标识为媒介的信息互联互通机制，实现数据开放和共享，为粤港澳大湾区深度合作区提供一个可信的数据基础设施。
</p>
<p>
	<br>
</p>
<p style="text-align:center;">
	<strong>浪潮云洲链宣布全面接入“星火·链网”</strong>
</p>
<p>
	2021年4月19日，在首届济南人工智能创新应用先导区高端峰会上，举办了浪潮云洲链全面接入“星火·链网”的启动仪式，浪潮云洲链宣布全面接入“星火·链网”,区块链与工业互联网深度融合发展叠加创新动力。在济南市副市长孙斌、山东省工业和信息化厅副厅长安文建、中国信通院副院长魏亮的共同见证下，济南市市中区区委副书记、区长翟立波与中国信通院工业互联网与物联网研究所所长金键代表双方签署“星火·链网”超级节点（济南）意向落地合作协议，金键与肖雪签署深化合作协议。云洲链是浪潮云洲工业互联网平台的重要组成。浪潮将国家标识解析体系与区块链、商用密码技术融合，形成的增强级标识体系服务平台。本次浪潮云洲链全面接入“星火·链网”，将进一步扩大“星火·链网”生态，支持“星火·链网”济南超级节点建设，推动山东省的数字经济建设；依托浪潮云洲工业互联网平台，更好地服务于智能制造，打造多元化场景的落地实践。双方将围绕“星火·链网”区块链新型基础设施，共同开展核心架构设计、体系建设、标准制定、应用场景探索等工作，拓展生态运营合作，以点带面进一步形成立足山东、辐射东部沿海乃至全国的先进制造业和数字经济发展新高地。
</p>
                    </div>
                    <div class="art-bott flex flex-wrap-wrap flex-justify-between flex-align-center">
                        <a href="/News/1" class="art-btn btn-hvr" ondragstart="return false">返回</a>
                        
                    </div>
                    <div class="arc-nav">
                        <a href="/NewsDetail/54" ondragstart="return false">上一条 :  横琴创新应用“澳优码”亮相首届BEYOND国际科技创新博览会</a>
                        <a href="/NewsDetail/37" ondragstart="return false">下一条 : “星火·链网”骨干节点（珠海横琴）上线发布 创新赋能数字贸易</a>
                    </div>
                </div>
</template>
  
  <script setup>
  import { ref, onMounted, onUnmounted } from 'vue';
  
  const startAnimate = ref(false)


  onMounted(() => {
    startAnimate.value = true
  });
  
  onUnmounted(() => {
    startAnimate.value = false
  });
  </script>
  
  <style scoped>
 .article .art-cont {
    background: #fff;
    width: calc(70% - 80px);
    padding: 50px 40px;
    overflow: hidden;
    border-radius: 8px;
}
.article .art-cont h1 {
    color: #333;
    font-weight: 700;
}
    .article .art-cont h1 {
        font-size: 26px;
    }

    .article .art-cont .title-info {
        font-size: 14px;
        color: #888;
        font-family: OPPOSans-H;
        padding-left: 30px;
        height: 20px;
        line-height: 22px;
        background: url(@/assets/images/news-time.png) no-repeat left center;
        margin: 30px 0;
    }

    .article .art-bott {
        margin-top: 50px;
        display: flex;
        justify-content: space-between;
        padding-bottom: 30px;
        margin-bottom: 30px;
        border-bottom: 1px solid #f0f0f0;
        align-items: center;
    }
    .article .art-bott .art-btn {
        background: #ea5413;
        display: flex;
        align-items: center;
        justify-content: center;
        width: 110px;
        height: 42px;
        font-weight: 700;
        color: #fff;
        border-radius: 30px;
        transition: all .4s ease;
        font-size: 16px;
    }
    .btn-hvr:hover {
        border-color: transparent;
        box-shadow: 0 0 0 .2rem rgba(234, 84, 19, .5);
    }
    .article .arc-nav a {
        position: relative;
        display: block;
        font-size: 14px;
        color: #666;
        padding-left: 15px;
        transition: all .4s ease;
        font-weight: 700;
    }

  </style>